// Helpers de gravação de áudio (MediaRecorder) com feature-detect p/ iOS/Safari.

export function pickMime(): string {
  const opts = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4", "audio/ogg"];
  const supported = (m: string) => typeof MediaRecorder !== "undefined" && (MediaRecorder as any).isTypeSupported?.(m);
  for (const m of opts) if (supported(m)) return m;
  return "";
}

export async function ensureMicPermission(): Promise<boolean> {
  try {
    if (!navigator.mediaDevices?.getUserMedia) return false;
    const p = navigator.mediaDevices.getUserMedia({ audio: true });
    const timeout = new Promise<MediaStream>((_, rej) => setTimeout(() => rej(new Error("mic-timeout")), 6000));
    const s = await Promise.race([p, timeout]);
    s.getTracks().forEach((t) => t.stop());
    return true;
  } catch {
    return false;
  }
}

export interface Recorder {
  stop: () => Promise<{ blob: Blob; mime: string; duration: number }>;
  cancel: () => void;
}

export async function startRecorder(): Promise<Recorder> {
  const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  const mime = pickMime();
  const rec = new MediaRecorder(stream, mime ? { mimeType: mime } : undefined);
  const chunks: BlobPart[] = [];
  rec.ondataavailable = (e) => { if (e.data && e.data.size) chunks.push(e.data); };
  rec.start();
  const started = Date.now();
  const cleanup = () => stream.getTracks().forEach((t) => t.stop());
  return {
    stop: () =>
      new Promise((resolve) => {
        rec.onstop = () => {
          cleanup();
          const type = mime || "audio/webm";
          resolve({ blob: new Blob(chunks, { type }), mime: type, duration: (Date.now() - started) / 1000 });
        };
        rec.stop();
      }),
    cancel: () => { try { rec.stop(); } catch { /* noop */ } cleanup(); },
  };
}
